import { render, staticRenderFns } from "./GastoContablePage.vue?vue&type=template&id=2cceb7a3"
import script from "./GastoContablePage.js?vue&type=script&lang=js&external"
export * from "./GastoContablePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports